import { usePathname, useSearchParams } from 'next/navigation'
import queryString from 'query-string'

export function useFullDomainUrl() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const query = queryString.stringify(Object.fromEntries(searchParams))
  const fullUrl = `${process.env.NEXT_PUBLIC_ENV === 'prod' ? 'https://www.ddokso.com' : process.env.NEXT_PUBLIC_ENV === 'dev' ? 'https://www.dev.ddokso.com' : 'localhost:3000'}${pathname}${query ? `?${query}` : ''}`

  return fullUrl
}
